<template>
  <section>
    <div class="row" v-if="isStatusBase">
      <div class="col-12 my-2">
        <a
          role="button"
          class="btn btn-success px-10-py-5 extra-rounded text-center d-block"
          data-toggle="modal"
          data-target="#receiveConfirmWindow"
        >
          {{ trans('direct.button_confirm') }}
        </a>
        <!-- Modal of confirm receiving -->
        <div
          class="modal fade"
          id="receiveConfirmWindow"
          tabindex="-1"
          role="dialog"
          aria-labelledby="receiveConfirmWindowTitle"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="receiveConfirmWindowTitle">{{ trans('direct.confirm_title') }}</h5>
                <button type="button" class="btn-close" data-dismiss="modal" aria-label="Lukk"></button>

              </div>
              <div class="modal-body text-success">
                {{ trans('direct.confirm_text') }}
              </div>
              <div class="modal-footer">
                <button
                  ref="close_confirm"
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                >{{ trans('direct.button_close') }}</button>
                <button
                  type="button"
                  class="btn btn-success"
                  @click="confirmReceive"
                >{{ trans('direct.button_confirm') }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 my-2">
        <a
          role="button"
          class="btn btn-warning px-10-py-5 extra-rounded text-center d-block"
          data-toggle="modal"
          data-target="#questionModal"
          @click="mode='confirm'"
        >
          {{ trans('direct.button_complaint') }}
        </a>
      </div>
      <div class="col-12 my-2">
        <a
          role="button"
          class="px-10-py-5 extra-rounded text-center btn-danger d-block text-decoration-none"
          data-toggle="modal"
          data-target="#questionModal"
          @click="mode='reject'"
        >{{ trans('direct.button_reject') }}</a>
        <!-- Modal of reject receiving -->
        <div
          class="modal fade"
          id="questionModal"
          tabindex="-1"
          aria-labelledby="questionModalLabel"
          aria-hidden="true">
          <div class="modal-dialog modal-lg">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="questionModalLabel">{{ trans('direct.reject_title') }}</h5>
                  <button type="button" class="btn-close" data-dismiss="modal" aria-label="Lukk"></button>
                </div>
                <div class="modal-body">
                  <div class="pt-3 text-danger">{{ trans('direct.reject_text') }}</div>
                  <textarea
                    v-model="complaintMessage"
                    name="question"
                    id="question"
                    class="form-control"
                    rows="10"></textarea>
                  <div class="mb-3 pt-3">
                    <label for="files" class="form-label">{{trans('complaints.new.attachments')}}</label>
                    <input
                      class="form-control"
                      multiple type="file"
                      id="files"
                      ref="files"
                      name="files[]" />
                  </div>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-secondary" data-dismiss="modal">
                    {{ trans('direct.button_close') }}
                  </button>
                  <button
                    v-if="mode==='reject'"
                    type="button"
                    class="btn btn-danger"
                    @click="rejectReceive()"
                    :disabled="!complaintMessage"
                    data-dismiss="modal"
                  >{{ trans('direct.button_reject') }}</button>
                  <button
                    v-if="mode==='confirm'"
                    type="button"
                    class="btn btn-warning"
                    @click="confirmWithComplaint"
                    :disabled="!complaintMessage"
                    data-dismiss="modal"
                  >{{ trans('direct.button_complaint') }}</button>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="isStatusReceived">
      <div v-if="mode==='confirm'" class="coll alert alert-warning fs-5">Mottaket er ferdig.
        <br/> Reklamasjon er opprettet.
      </div>
      <div v-else class="coll alert alert-success fs-5">Mottaket er ferdig</div>
    </div>
    <div class="row" v-if="isStatusRejected">
      <div class="coll alert alert-danger fs-5" data-v-57d9b895="">Mottak avvises.<br />Reklamasjon er opprettet</div>
    </div>
    <div class="row" v-if="isStatusWaiting">
      <div class="coll alert alert-info">
        {{ trans('direct.waiting_text') }}
      </div>
    </div>

  </section>
</template>

<script>

const STATUS_WAITING_SELLER = 'waiting';
const STATUS_BASE = '';
const STATUS_RECEIVED = 'received';
const STATUS_REJECTED = 'rejected';
export default {
  name: "ReceiveCarComponent",
  props: {
    token: {
      required: true,
      type: String,
    },
    car_id: {
      required: true,
      type: Number,
    },
    user_id: {
      required: true,
      type: Number,
    },
    lot_id: {
      required:true,
    },
    status: {
      type: String,
      default: STATUS_BASE,
    }
  },
  data: function () {
    return {
      currentStatus: '',
      complaintMessage: '',
      files: null,
      mode: null,
    }
  },
  computed: {
    isStatusBase() {
      return this.currentStatus === STATUS_BASE
    },
    isStatusReceived() {
      return this.currentStatus === STATUS_RECEIVED
    },
    isStatusRejected() {
      return this.currentStatus === STATUS_REJECTED
    },
    isStatusWaiting() {
      return this.currentStatus === STATUS_WAITING_SELLER
    },

  },
  mounted() {
    this.currentStatus = this.status
  },
  methods: {
    confirmReceive: function () {
      axios.put('/receive/' + this.token + '/confirm')
        .then(() => {
          this.$refs.close_confirm?.click()
          this.currentStatus = STATUS_RECEIVED;
        }).catch(err => {
          console.log('ERR', err)
        }).finally(() => {
          this.$refs.close_confirm?.click()
        })
    },
    rejectReceive: function () {
      const formData = this.prepareFormData();

      axios.post( '/receive/' + this.token + '/reject',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      ).then(() => {
        this.currentStatus = STATUS_REJECTED;
      })
        .catch(err =>{
          console.error('FAILURE!!', err);
        });
    },
    confirmWithComplaint: function () {
      const formData = this.prepareFormData();

      axios.post( '/receive/' + this.token + '/confirm_complaint',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      ).then(() => {
        this.currentStatus = STATUS_RECEIVED;
      })
        .catch(err =>{
          console.error('FAILURE!!', err);
        });
    },

    prepareFormData: function() {
      let formData = new FormData();
      for (let i = 0; i < this.$refs.files.files.length; i++ ){
        let file = this.$refs.files.files[i];
        formData.append('files[' + i + ']', file);
      }
      formData.append('question', this.complaintMessage);

      return formData;
    },
  },
}

</script>

<style scoped>
.btn-danger:focus, .btn-danger:active {
  background-color: inherit !important;
}
</style>
